import React from 'react';

/**
 * fix-017 — which preview AcDropzone opens when its thumbnail is clicked, so it
 * matches the product image preview of the screen that hosts it:
 *  - "zoom"   (default): AcLightBox, the zoomable lightbox the legacy Master Data
 *             product screen uses for its own product image.
 *  - "simple": the plain full-screen lightbox simV3's Product Information tab uses
 *             (.pdm-lightbox look, .dzone-lightbox in App.scss).
 *
 * Dependency-free on purpose: simV3 imports it, and must not pull in AcComps'
 * legacy import chain (see OptionImageUpload's getAcDropzone).
 */
export type DropzonePreviewMode = 'zoom' | 'simple';

export const DropzonePreviewContext = React.createContext<DropzonePreviewMode>('zoom');
